import { Container, Row, Col } from "react-bootstrap";

function SinglePageHeader() {
  return (
    <div className="header-background-img-wrapper mb-5">
      <Container>
        <Row>
          <Col md={12} className="text-center">
            <h1 className="header-title">
              Onboarding <span>Initiation</span>
            </h1>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default SinglePageHeader;
